"use client"

import { DayPicker } from "react-day-picker"
import { format } from "date-fns"

const languageToWeekStartDay = (language: string) => {
  return !!language && ["en", "en-US", "pt", "pt-PT"].includes(language) ? 0 : 1;
}

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  mode = "single",
  locale,
  ...props
}: any) {
  const today = new Date()
  today.setHours(0, 0, 0, 0)

  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={`p-3 ${className}`}
      classNames={{
      // Example of classes: https://daypicker.dev/docs/styling
      //   months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
      //   month: "space-y-4",
      // caption: "flex justify-center pt-1 relative items-center",
      //   caption_label: "text-sm font-medium",
        ...classNames,
      }}
      mode={mode}
      formatters={{
        formatCaption(month) {
          return format(month, "LLLL yyyy", { locale: locale })
        },
        formatWeekdayName(date) {
          return format(date, "EEE", { locale: locale })
        },
      }}
      weekStartsOn={languageToWeekStartDay(locale)}
      {...props}
    />
  )
}

Calendar.displayName = "Calendar"

export { Calendar }